import { Box, Text, Flex } from "@chakra-ui/react";
import {
    LOAN_TYPE_COLORS,
    formatEntryName,
} from "components/analytics/LoanTypeBreakdown";
import { LoanStatusPieItem } from "./types/loan-status-pie-item";

export function LoanStatusPieLegend({ data }: { data: LoanStatusPieItem[] }) {
    return (
        <Flex
            direction={"column"}
            gap={1}
            maxHeight={"200px"}
            overflowY={"auto"}
        >
            {data.map((entry, index) => (
                <Flex
                    key={`item-${index}`}
                    justifyContent="space-between"
                    alignItems={"center"}
                >
                    <Flex gap={1} alignItems={"center"}>
                        <Box
                            bg={
                                LOAN_TYPE_COLORS[
                                    index % LOAN_TYPE_COLORS.length
                                ]
                            }
                            width="10px"
                            height="10px"
                            borderRadius="sm"
                            mr={1}
                        />
                        <Text
                            color="#171B1E"
                            fontWeight="500"
                            fontSize="12px"
                            overflow={"hidden"}
                            textOverflow={"ellipsis"}
                            whiteSpace={"nowrap"}
                            height={"16px"}
                        >
                            {formatEntryName(entry.name)}
                        </Text>
                    </Flex>
                    <Text
                        color="#171B1E"
                        fontWeight="500"
                        fontSize="12px"
                        align={"right"}
                        overflow={"hidden"}
                        height={"16px"}
                        whiteSpace={"nowrap"}
                        textOverflow={"ellipsis"}
                    >
                        {entry.formatedValue}
                    </Text>
                </Flex>
            ))}
        </Flex>
    );
}
